<template>
  <div class="table-action-buttons" :class="{ 'table-action-buttons--stacked': stacked }">
    <template v-for="(action, index) in visibleActions">
      <v-btn
        :key="index"
        x-small
        depressed
        class="table-action-btn text-capitalize"
        :class="buttonClass(action)"
        :disabled="action.disabled"
        :href="action.href"
        :target="action.target"
        :rel="action.target ? 'noopener' : null"
        @click="handleClick(action, $event)"
      >
        {{ action.label }}
      </v-btn>
    </template>
  </div>
</template>

<script>
export default {
  name: 'TableActionButtons',
  props: {
    actions: {
      type: Array,
      default: () => []
    },
    stacked: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    visibleActions() {
      return this.actions.filter(action => action && !action.hidden)
    }
  },
  methods: {
    buttonClass(action) {
      return `table-action-btn--${action.variant || 'primary'}`
    },
    handleClick(action, event) {
      if (action.disabled) {
        event.preventDefault()
        return
      }
      if (typeof action.onClick === 'function') {
        action.onClick(event)
      }
      this.$emit('action', action, event)
    }
  }
}
</script>
